import { useAppTranslation } from '@hooks/useAppTranslation';
import { ScrollView } from 'react-native';
import { SizableText, YStack } from 'tamagui';
import {
  CsvValidationError,
  ValidatedCsvReportResult,
} from '@screens/ReportCreation/components/CsvImport/types/csvValidation.types';

interface CsvImportValidationResultProps {
  result: ValidatedCsvReportResult;
}

export const CsvImportValidationResult = ({
  result,
}: CsvImportValidationResultProps): React.ReactElement => {
  const { t } = useAppTranslation();

  return (
    <YStack
      borderWidth={1}
      borderColor={result.errors.length > 0 ? '$error' : '$secondary'}
      backgroundColor="$tertiary25"
      padding="$3"
      gap="$2"
    >
      <SizableText size="$3" fontFamily="$bold">
        {result.errors.length > 0
          ? t('reportCreation.csvImportValidation.summary.invalid', {
              totalRows: result.totalRows,
              validRows: result.validRows,
              invalidRows: result.invalidRows,
            })
          : t('reportCreation.csvImportValidation.summary.valid', {
              totalRows: result.totalRows,
            })}
      </SizableText>

      {result.errors.length > 0 && (
        <ScrollView style={{ maxHeight: 180 }}>
          <YStack gap="$2">
            {result.errors.map((error: CsvValidationError, index: number) => (
              <SizableText key={`${error.rowNumber}-${index}`} size="$2">
                {t('reportCreation.csvImportValidation.errorRowLabel', {
                  rowNumber: error.rowNumber,
                  columnHeader: error.columnHeader,
                })}
                {`: ${error.message}`}
              </SizableText>
            ))}
          </YStack>
        </ScrollView>
      )}
    </YStack>
  );
};
